// Auth services
export const AUTH_API_PATH = 'auth';
// Get user data
export const FETH_USER = '/api/v1/users';
export const SELLERS_URL = '/api/v1/sellers';

export const SWAGGER_INBOUND_URL = '/api/v1/auth/inbound/spec';
export const SWAGGER_MOCK_SELLER_URL = '/api/v1/auth/mock-api/spec';
